import { DevShell, type DevShellLinkRenderer } from '@frontend-platform/dev-shell';
import { isFederated } from '@frontend-platform/federation-runtime';
import { Link, Outlet, useLocation } from '@tanstack/react-router';
import { isUsingMockApi, setUseMockApi } from '@/features/calibration-runs';
import { queryClient } from '@/shared/lib/query-client';
import { OBSERVATION_TOOLS_SIDEBAR } from '../sidebar-config';

const renderRouterLink: DevShellLinkRenderer = ({ href, className, children, label }) => (
  <Link to={href} className={className} aria-label={label} title={label}>
    {children}
  </Link>
);

export function RootLayout() {
  const { pathname } = useLocation();
  const page = (
    // pt-8 px-6 pb-6 === aistudio's `padding: 32px 24px 24px` on
    // #aiStudio-wrapper__views, so a federated route lines up with the
    // native ones. Page components must not add their own padding on top.
    <main className="flex h-full flex-1 flex-col overflow-y-auto px-6 pt-8 pb-6">
      <Outlet />
    </main>
  );

  if (import.meta.env.PROD || isFederated()) {
    return <div className="flex h-full min-h-0 flex-col bg-white">{page}</div>;
  }

  return (
    <DevShell
      config={{
        projectName: 'observation-tools',
        envToggle: {},
        mockApi: {
          isEnabled: isUsingMockApi,
          setEnabled: (next) => {
            setUseMockApi(next);
            queryClient.clear();
          },
        },
      }}
      sidebar={OBSERVATION_TOOLS_SIDEBAR}
      pathname={pathname}
      renderLink={renderRouterLink}
    >
      {page}
    </DevShell>
  );
}
